<!-- <div class="css-Campo_Texto campo_texto">
    <div class="css-Campo campo">
        <textarea [(ngModel)]="modelValue" class="css-textarea_Texto textarea_texto" name="textarea_texto"
            placeholder="{{placeholder_input}}" (ngModelChange)="onInputChange($event)"></textarea>
        <div *ngIf="attachment" class="css-Adjuntar_ancho adjuntar_ancho">
            <div class="css-Boton_Adjuntar-2 boton_adjuntar">
                <input class="attach-inputfile" #fileInput type="file" multiple (change)="attachFiles($event)"
                    id="id_attachment" />
                <button (click)="onUploadClick()" type="button" class="css-button_adjuntar-2 button_adjuntar"
                    name="comp_boton_adjuntar">
                    <div class="css-adjuntar-2 adjuntar">
                        <div class="css-Icono_Adjuntar icono_adjuntar">
                            <img src="assets/images/basecomponents-images/campo-texto.svg" width="15.166625976562px"
                                height="8.2947998046875px" class="css-Vector_attach_file vector_attachfile">
                        </div>
                        <p class="css-Texto-8 texto">Adjuntar</p>
                    </div>
                </button>
            </div>
        </div>
        <div *ngIf="attachment && attachments.length > 0">
            <table class="attach_table">
                <tr *ngFor="let file of attachments" class="attach_table_data">
                    <td><span style="background-color: #f8f9fa;border-radius: 2px; "> 📄​ {{ file.name }} <b
                                style="cursor: pointer; " (click)="eliminarAdjunto(file.name)">x</b></span></td>
                </tr>
            </table>

        </div>
    </div>
    <div class="mensaje_error" *ngIf="mensaje_error.length > 0">
        <div class="css-Icono_Error_Forms-1 icono_error_forms">
            <img src="assets/images/basecomponents-images/campo-default.svg" width="9px" height="9px"
                class="css-close close">
        </div>
        <p class="css-Texto-1 texto">{{mensaje_error}}</p>
    </div>
    <div class="mensaje_error" *ngIf="attachmentsErrorMessage.length > 0">
        <div class="css-Icono_Error_Forms-1 icono_error_forms">
            <img src="assets/images/basecomponents-images/campo-default.svg" width="9px" height="9px"
                class="css-close close">
        </div>
        <p class="css-Texto-1 texto">{{attachmentsErrorMessage}}</p>
    </div>

</div> -->

<div class="css-campo_Area_texto-1 campo_area_texto">
  <label
    class="css-label_Area_texto-1 label_area_texto"
    for="textarea-{{ id }}"
    >{{ etiqueta }}</label
  >
  <div class="css-agrupador_mensajes_textarea-1 agrupador_mensajes_textarea">
    <textarea
      id="textarea-{{ id }}"
      placeholder="{{ placeholder_input }}"
      (ngModelChange)="onInputChange($event)"
      class="css-textarea_Area_texto-1 textarea_area_texto"
      [(ngModel)]="modelValue"
    ></textarea>
    <div class="css-contador_caracteres-1 contador_caracteres">
      <p class="css-numero_caracteres-1 numero_caracteres">
        Caracteres: {{ modelValue.length }}/{{ caracteres_maximo }}
      </p>
    </div>
    <div
      *ngIf="mensaje_ayuda"
      class="css-mensaje_ayuda_Area_texto-1 mensaje_ayuda_area_texto"
    >
      <p
        class="css-texto_mensaje_ayuda_Area_texto-1 texto_mensaje_ayuda_area_texto"
      >
        {{ mensaje_ayuda }}
      </p>
    </div>
    <div
      *ngIf="mensaje_error"
      class="css-mensaje_error_Area_texto-1 mensaje_error_area_texto"
    >
      <!-- Instance of sub-component comp-icon-mensaje-error -->
      <app-mensaje-error [mensaje_error]="mensaje_error"></app-mensaje-error>
    </div>
  </div>
</div>
